import { render, staticRenderFns } from "./usercoupon-add-or-update.vue?vue&type=template&id=2e56239d&"
import script from "./usercoupon-add-or-update.vue?vue&type=script&lang=js&"
export * from "./usercoupon-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports